import React from 'react';
import { NavigationCardProps } from './types';
import { Wrapper, IconWrapper, Text } from './navigation-card.styles';

export const NavigationCard: React.FC<NavigationCardProps> = ({ href, text, children }) => {
    return (
        <Wrapper to={href} exact>
            <IconWrapper>{children}</IconWrapper>
            <Text size='body1_short' as='p'>
                {text}
            </Text>
        </Wrapper>
    );
};
